export const WHATSAPP_NUMBER = "919953198325";
export const WHATSAPP_DISPLAY = "+91 99531 98325";

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const WA_DEFAULT_MSG =
  "Hi Rajkiran Wealth, I visited your website and would like to know more. Please call me back.";
